// extracted by mini-css-extract-plugin
export default {"container":"tag_modal_container__kXQf2","content":"tag_modal_content__nZj3K","title":"tag_modal_title__Gxf2x","checkbox":"tag_modal_checkbox__8Da8e"};